/**
 * Maps any DB role alias to a canonical role string expected by the backend.
 */
export function normalizeRole(roleName = "") {
  const r = roleName.toLowerCase().trim();
  if (r.includes("system admin"))                                                                    return "System Admin";
  if (r === "admin" || r.includes("administrator"))                                                  return "Admin";
  if (r.includes("human resource") || ["hr", "hrs"].includes(r))                                    return "HR";
  if (r.includes("project manager") || ["pm", "pms"].includes(r))                                   return "Project Manager";
  if (r.includes("technical lead") || r.includes("tech lead") || ["tl", "tls"].includes(r))        return "Technical Lead";
  return "Employee";
}

/** Roles that are allowed to access the Leave Approval page */
export const APPROVAL_ROLES = ["Technical Lead", "Project Manager", "HR", "Admin", "System Admin"];
